<template>
    <div class="nw-affi-bg"></div>

    <section class="nw-affi-user-wrapper affi-pd-bot">
        <div class="">
            <!-- <div class="nw-affi-pl-top-head">
                <div class="nw-affi-heading-flex">
                    <h3 class="nw-affi-heading-text">Profit and Loss Evets</h3>
                    <div class="dropdown">
                        <button class="nw-affi-more-info dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                            All Events
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                            <li><a class="dropdown-item" href="#">Action</a></li>
                            <li><a class="dropdown-item" href="#">Another action</a></li>
                            <li><a class="dropdown-item" href="#">Something else here</a></li>
                        </ul>
                    </div>
                </div>
                <div class="nw-affi-pl-content-wrapper">
                    <div class="nw-affi-pl-content-sec">
                        <span class="nw-affi-trens-icn affi-green-text"><span class="fa-solid fa-arrow-trend-up"></span></span>
                        <h3 class="affi-green-text">9086798</h3>
                        <p>Total Profit</p>
                    </div>
                    <div class="nw-affi-pl-content-sec">
                        <span class="nw-affi-trens-icn affi-red-text"><span class="fa-solid fa-arrow-trend-up"></span></span>
                        <h3 class="affi-red-text">9086798</h3>
                        <p>Total loss</p>
                    </div>
                    <div class="nw-affi-pl-content-sec">
                        <span class="nw-affi-trens-icn affi-green-text"><span class="fa-solid fa-arrow-trend-up"></span></span>
                        <h3 class="affi-green-text">9086798</h3>
                        <p>Total p&l</p>
                    </div>
                </div>
            </div> -->

            <form class="typeslabel openbettss affiliate-pl affiliate-report affi-date-filter-form">
                <ul class="typelabel-main flex-nowrap me-2">
                    <li>
                        <div class="form-group">
                            <input type="date" id="open-bet-from" class="form-control" v-model="fromDate" />
                        </div>
                    </li>
                    <li>
                        <div class="form-group">
                            <input v-model="toDate" type="date" id="open-bet-from" class="form-control" />
                        </div>
                    </li>
                </ul>
                <div class="download-main">
                    <div class="subbtn">
                        <!-- <button class="nw-affi-add-new-user-btn" @click.prevent="getAffiliateUsersList()">{{ $t('submit','Submit') }}</button> -->
                        <button type="text" class="submit-btn rounded thm-but" @click.prevent="getProfitLossEventUsers()">{{ $t('submit','Submit') }}</button>
                    </div>
                </div>
            </form>

            <div class="nw-affi-user-list-wrapper">
                <h3 class="nw-affi-heading-text">User Profit / Loss</h3>
                <div class="table-responsive nw-affi-user-table">
                    <table class="table">
                        <thead>
                            <tr>
                                <th><img src="@/assets/images/affi-user-icn.svg" alt="affi-user-icn" />
                                    Date
                                </th>
                                <th><img src="@/assets/images/affi-star.svg" alt="affi-star" />
                                    Event
                                </th>
                                <th>
                                    <img src="@/assets/images/affi-calendar.svg" alt="affi-calendar" />
                                    Profit / Loss
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(pl, pIndex) in affPl" :key="pIndex">
                                <td>{{pl.date}}</td>
                                <td>{{pl.type}}</td>
                                <td>
                                    <span class="affi-green-text" :class="pl.pl < 0 ? 'red-font-color' : 'green-font-color'">
                                        {{pl.pl}}
                                        <!-- <span class="fa-solid fa-arrow-trend-up"></span> -->
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </section>

    <!-- <section class="af-top-user-wrapper">
        <div class="container">
            <form class="typeslabel openbettss affiliate-pl w-75 d-flex">
                <ul class="typelabel-main flex-nowrap me-2">
                    <li>
                        <div class="form-group">
                            <input type="date" id="open-bet-from" class="form-control" v-model="fromDate" />
                        </div>
                    </li>
                    <li>
                        <div class="form-group">
                            <input v-model="toDate" type="date" id="open-bet-from" class="form-control" />
                        </div>
                    </li>
                </ul>
                <div class="download-main">
                    <div class="subbtn">
                        <button type="text" class="submit-btn rounded" @click.prevent="getProfitLossEventUsers()">{{ $t('submit','Submit') }}</button>
                    </div>
                </div>
            </form>
            <div class="af-top-user-sec">
                <div class="af-top-user-head af-new-user-add-sec">
                    <h6>User Profit/Loss</h6>
                </div>
                <div class="table-responsive">
                    <table class="table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Event</th>
                            <th>Profit/Loss</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(pl, pIndex) in affPl" :key="pIndex">
                            <td>{{pl.date}}</td>
                            <td>{{pl.type}}</td>
                            <td :class="pl.pl < 0 ? 'red-font-color' : 'green-font-color'">{{pl.pl}}</td>
                        </tr>
                        
                    </tbody>
                    </table>
                </div>
            </div>
            
        </div>
    </section> -->
    <ShareAffiliate/>
</template>


<script>
import { defineAsyncComponent } from 'vue';
export default {
    name: 'ProfitLoss',
    components: {
        ShareAffiliate: defineAsyncComponent(() => import('../components/ShareAffiliateModal.vue')),
    },
    data(){
        return{
            totalPage: null,
            pageNo: 1,
            pageEntries: 25,
            fromDate: this.$dateTime.getDateSaperatedByDays(1),
            toDate: this.$dateTime.getaffcurrentDate(new Date(),'YYYY-MM-DD'),
            affPl: []
        }
    },
    created(){
        this.getProfitLossEventUsers()
    },
    methods:{
        getProfitLossEventUsers() {
            this.$store.dispatch('setGlobalLoader', true);
            let data = {
                "from": this.$dateTime.getaffcurrentDate(this.fromDate,'YYYY-MM-DD'),
                "to": this.$dateTime.getDateAddedByDays(1, this.toDate,'YYYY-MM-DD')
            }
			this.$apiCall('post', 'GET_PROFIT_LOSS_EVENT_USERS', data).then(response => {
				if (response && response.status == 200) {
                    this.$store.dispatch('setGlobalLoader', false);
					if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {
                        this.affPl = response.data.data
					}
				}
			}).catch(error => {	
                this.$store.dispatch('setGlobalLoader', false);
				if (error) {
					this.$errorToast(error[0]);
				}
			});
		},
        clickOnPaginationPage(page) {
            this.pageNo = page;
            this.getAffiliateUsersList();
        },
    }
}

</script>
<style scoped>
.affiliate-pl .typelabel-main li {
    flex: 1 40%;
}

.affiliate-pl .typelabel-main li .form-group {
    width: 130px;
}

.af-top-user-sec {
    margin-top: -10px;
}
</style>